import gql from 'graphql-tag';

const GET_GLOBAL_OVERRIDDEN_PATCH_APPROVAL_CONFIGS = gql`
  query($listInfo: ListInfoInput!) {
    getGlobalOverriddenPatchApprovalConfigs(listInfo: $listInfo) {
      overriddenPatchApprovalConfigs {
        configId
        lastUpdatedBy {
          userId
          name
        }
        title
        description
        lastUpdatedTime
        approvalBased
        approvalState
        approvalValue
      }
      listInfo {
        page
        pageSize
        totalCount
        sort {
          attribute
          order
        }
      }
    }
  }
`;
const ADD_GLOBAL_OVERRIDDEN_PATCH_APPROVAL_CONFIG = gql`
  mutation($input: OverriddenPatchApprovalConfigInput!) {
    addGlobalOverriddenPatchApprovalConfig(input: $input) {
      configId
      approvalBased
      approvalValue
      approvalState
      description
      lastUpdatedBy {
        userId
        name
      }
      lastUpdatedTime
    }
  }
`;

const UPDATE_GLOBAL_OVERRIDDEN_PATCH_APPROVAL_CONFIG = gql`
  mutation($input: OverriddenPatchApprovalConfigInput!) {
    updateGlobalOverriddenPatchApprovalConfig(input: $input) {
      configId
      approvalBased
      approvalValue
      approvalState
      description
      lastUpdatedBy {
        userId
        name
      }
      lastUpdatedTime
    }
  }
`;

const DELETE_GLOBAL_OVERRIDDEN_PATCH_APPROVAL_CONFIG = gql`
  mutation($configIds: [ID!]) {
    deleteGlobalOverriddenPatchApprovalConfigs(configIds: $configIds)
  }
`;

const GET_OVERRIDDEN_PATCH_APPROVAL_CONFIG = gql`
  query($policyId: ID!) {
    getPolicy(policyId: $policyId) {
      policyId
      name
      overriddenPatchApprovalConfigs {
        configId
        approvalBased
        approvalStatus
        approvalValue
      }
    }
  }
`;

export {
  GET_GLOBAL_OVERRIDDEN_PATCH_APPROVAL_CONFIGS,
  ADD_GLOBAL_OVERRIDDEN_PATCH_APPROVAL_CONFIG,
  UPDATE_GLOBAL_OVERRIDDEN_PATCH_APPROVAL_CONFIG,
  DELETE_GLOBAL_OVERRIDDEN_PATCH_APPROVAL_CONFIG,
  GET_OVERRIDDEN_PATCH_APPROVAL_CONFIG
};
